import React from 'react';
import { CSSTransition } from 'react-transition-group';

import { useSnackbar } from './Snackbar.hook';
import {
  SnackbarAction,
  SnackbarContainer,
  SnackbarText,
} from './Snackbar.styled';

export const Snackbar: React.FC = () => {
  const {
    show,
    message,
    actionText,
    formFactor,
    hasAction,
    isTextCentered,
    handleMouseEnter,
    handleMouseLeave,
    handleAction,
    handleExited,
  } = useSnackbar();

  return (
    <CSSTransition
      classNames={{
        enter: 'snackbar-enter',
        exit: 'snackbar-exit',
      }}
      in={show}
      onExited={handleExited}
      timeout={300}
      unmountOnExit
    >
      <SnackbarContainer
        $formFactor={formFactor}
        $hasAction={hasAction}
        aria-labelledby="snackbar-message"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        role="alert"
      >
        <SnackbarText
          $centered={isTextCentered}
          aria-label={message}
          id="snackbar-message"
        >
          {message}
        </SnackbarText>
        {hasAction && (
          <SnackbarAction
            aria-label={actionText}
            onClick={handleAction}
            tabIndex={0}
          >
            {actionText}
          </SnackbarAction>
        )}
      </SnackbarContainer>
    </CSSTransition>
  );
};
